import { z } from 'zod';

const toNonEmptyString = (value: unknown): string | null => {
  if (typeof value !== 'string') {
    return null;
  }

  const normalized = value.trim();
  return normalized.length > 0 ? normalized : null;
};

const getArrayMessage = (value: unknown): string | null => {
  if (!Array.isArray(value)) {
    return null;
  }

  for (const item of value) {
    const message = getDisplayErrorMessage(item, '');
    if (message) {
      return message;
    }
  }

  return null;
};

export function getDisplayErrorMessage(error: unknown, fallback: string): string {
  if (error instanceof z.ZodError) {
    return toNonEmptyString(error.errors[0]?.message) ?? fallback;
  }

  if (error instanceof Error) {
    return toNonEmptyString(error.message) ?? fallback;
  }

  if (typeof error === 'string') {
    return toNonEmptyString(error) ?? fallback;
  }

  if (!error || typeof error !== 'object') {
    return fallback;
  }

  const typedError = error as {
    message?: unknown;
    helpText?: unknown;
    details?: unknown;
    errors?: unknown;
  };

  const primaryMessage: string | null =
    toNonEmptyString(typedError.message) ??
    getArrayMessage(typedError.errors) ??
    toNonEmptyString(typedError.details);
  const helpText = toNonEmptyString(typedError.helpText);

  if (primaryMessage && helpText && helpText !== primaryMessage) {
    return `${primaryMessage}\n${helpText}`;
  }

  return primaryMessage ?? helpText ?? fallback;
}
